import type { MtoLongLeadItem } from '@entities/mto';
import { fmtDate } from '@entities/mto';
import { Badge } from '@shared/ui/Badge';
import { daysOrDash, supplySource } from '../helpers';
import { Muted, Table, TableScroll, TrPending } from '../styles';

/**
 * Блок «Длинноцикловые позиции» (модуль 2.2) — read-only таблица позиций с
 * длительным сроком поставки: срок поставки, дата вовлечения, буфер, расчётная
 * точка заказа и признак запуска закупки. Просрочки и приближение точки заказа
 * идут через общий блок «Аномалии» — здесь не дублируются.
 */
export function LongLeadSection({ items }: { items: MtoLongLeadItem[] }) {
  if (items.length === 0) {
    return <Muted>Длинноцикловые позиции появятся после завершения обработки.</Muted>;
  }
  return (
    <TableScroll>
      <Table>
        <thead>
          <tr>
            <th scope="col">Наименование</th>
            <th scope="col" className="num">
              Срок поставки
            </th>
            <th scope="col">Дата вовлечения</th>
            <th scope="col" className="num">
              Буфер
            </th>
            <th scope="col">Точка заказа</th>
            <th scope="col">Заказано</th>
            <th scope="col">Источник</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <TrPending key={it.id} $pending={!it.ordered}>
              <td>{it.position_name}</td>
              <td className="num">{daysOrDash(it.lead_time_days)}</td>
              <td>{fmtDate(it.required_date)}</td>
              <td className="num">{daysOrDash(it.buffer_days)}</td>
              <td>{fmtDate(it.order_by_date)}</td>
              <td>
                {it.ordered ? (
                  <Badge $tone="success">да</Badge>
                ) : (
                  <Badge $tone="warning">нет</Badge>
                )}
              </td>
              <td>{supplySource(it.source_ref, it.source_file)}</td>
            </TrPending>
          ))}
        </tbody>
      </Table>
    </TableScroll>
  );
}
